// extracted by mini-css-extract-plugin
export var container = "_e7-0";
export var content = "_e7-3";
export var customerTitle = "_e7-4";
export var empty = "_e7-5";
export var gray = "_e7-6";
export var header = "_e7-7";
export var info = "_e7-8";
export var loading = "_e7-2";
export var loadingCard = "_e7-9";
export var oneLine = "_e7-a";
export var personName = "_e7-e";
export var pillContainer = "_e7-b";
export var selected = "_e7-1";
export var text = "_e7-c";
export var twoLines = "_e7-d";
export var unread = "_e7-f";
export var unreadIndicator = "_e7-g";